import watchdog from '@hll/watch-dog-jsutil';

interface WatchdonParams {
  id?: string;
  type: string;
}
export const initWatchdog = ({ id, type }: WatchdonParams) => {
  watchdog.setConfig({
    bizUserId: id,
    bizUserType: type,
    apiBizCodeParser: (url, status, responseText) => {
      if (url.indexOf('.xiaolachuxing.com') > -1 && status === 200) {
        // 解析 HTTP 响应中的业务状态码（看各业务接口的实际情况，这里只是示例用正则匹配）
        const match = (responseText || '').match(/^\{"ret":(\d+)/);
        return match ? match[1] : '';
      }
      return '';
    }
  });
};

export default initWatchdog;
